import { StorageItem } from '@page/core/lib/web/storage/StorageItem';

type PreviousAction = {
  [screen: string]: string | undefined;
};

const previousActionStorage = new StorageItem<PreviousAction>('auth-previous-action', {
  deserializer: (value) => {
    try {
      return JSON.parse(value) as PreviousAction;
    } catch (error) {
      return {};
    }
  },
});

export class AuthPreviousAction {
  #screen: string;

  constructor(screen: string) {
    this.#screen = screen;
  }

  get() {
    const previousAction = previousActionStorage.get();

    return previousAction?.[this.#screen];
  }

  set(action: string) {
    const previousAction = previousActionStorage.get();

    previousActionStorage.set({
      ...previousAction,
      [this.#screen]: action,
    });
  }

  remove() {
    const previousAction = previousActionStorage.get();

    previousActionStorage.set({
      ...previousAction,
      [this.#screen]: undefined,
    });
  }
}
